export const buildPromoAlert = promo => {
  if (!promo || promo.error || !promo.valid_for_order) {
    return;
  }

  const alert = document.querySelector('.alert--promo');
  const tagline = alert && alert.querySelector('.alert__tagline');

  if (promo.description && tagline && alert) {
    alert.classList.remove('alert--hidden');
    tagline.textContent = promo.description;
  }
};
